/**
 * Definições SVG da marca — a folha nunca some.
 *
 * - <symbol id="leaf"> : silhueta oficial (draft/style/elementos/folha.svg),
 *   reutilizada via <Leaf/> (bullet, marca d'água, ícones).
 * - clipPaths (#heroClip / #heroClipM / #leafCard) : divisores/curvas-folha
 *   em objectBoundingBox (responsivos), como no mockup do login.
 *
 * Montar UMA vez perto da raiz da app (fora do fluxo visual).
 */
export function LeafDefs() {
  return (
    <svg width={0} height={0} style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
      <symbol id="leaf" viewBox="0 0 588 289">
        <g transform="translate(0,289) scale(0.1,-0.1)" fill="currentColor">
          <path
            d="M4 2783 c28 -457 220 -1055 464 -1445 54 -87 79 -122 172 -243 287
            -375 757 -701 1270 -880 597 -208 1232 -260 2095 -170 505 52 734 75 860 85
            237 19 617 29 810 21 105 -5 194 -5 198 -1 16 15 -79 224 -181 395 -354 597
            -924 1080 -1577 1336 -97 38 -362 119 -391 119 -8 0 -14 5 -14 10 0 6 -15 10
            -32 10 -18 0 -107 14 -196 30 -90 17 -177 30 -192 30 -16 0 -31 4 -34 9 -3 4
            -61 11 -128 14 -249 13 -338 20 -338 26 0 3 -48 7 -108 8 -154 2 -503 24 -532
            32 -14 5 -59 9 -100 10 -192 5 -694 79 -911 135 -419 108 -820 304 -1072 525
            -32 28 -61 51 -64 51 -3 0 -3 -48 1 -107z"
          />
        </g>
      </symbol>

      {/* Divisor do hero (desktop): lateral de folha — curva Bézier única e suave. */}
      <clipPath id="heroClip" clipPathUnits="objectBoundingBox">
        <path d="M 0.17 0 C 0.015 0.30, 0.015 0.70, 0.17 1 L 1 1 L 1 0 Z" />
      </clipPath>
      {/* Divisor do hero (mobile): curva na base. */}
      <clipPath id="heroClipM" clipPathUnits="objectBoundingBox">
        <path d="M 0 0 L 1 0 L 1 0.82 C 0.70 1, 0.30 1, 0 0.82 Z" />
      </clipPath>
      {/* Forma-folha completa para cards (class="leaf-card"). */}
      <clipPath id="leafCard" clipPathUnits="objectBoundingBox">
        <path
          d="M 0 0.5 C 0.02 0.20, 0.13 0.05, 0.30 0.05 L 0.70 0.05
             C 0.87 0.05, 0.98 0.20, 1 0.5 C 0.98 0.80, 0.87 0.95, 0.70 0.95
             L 0.30 0.95 C 0.13 0.95, 0.02 0.80, 0 0.5 Z"
        />
      </clipPath>
    </svg>
  )
}

/** A folha oficial como ícone reutilizável (usa currentColor). */
export function Leaf({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg className={className} style={style} viewBox="0 0 588 289" aria-hidden="true">
      <use href="#leaf" />
    </svg>
  )
}
